(function () {
  const money = c => (c / 100).toLocaleString(undefined, {style:'currency', currency: window.Shopify ? Shopify.currency.active : 'USD'});
  const $ = s => document.querySelector(s);
  const all = s => Array.from(document.querySelectorAll(s));

  // Which photograph is showing. img.src reads back as an absolute URL while the
  // markup carries Shopify's protocol-relative one, so comparing the two finds
  // nothing and the arrows never move past the first step. The index is kept on
  // the element, with the raw attribute as the fallback.
  function shotAt(el, shots) {
    if (!el) return 0;
    const held = Number(el.dataset.at);
    if (el.dataset.at !== undefined && !isNaN(held)) return held;
    let i = shots.indexOf(el.getAttribute('src'));
    if (i < 0) i = shots.indexOf(el.src);
    if (i < 0) i = shots.findIndex(s => s && el.src.indexOf(s.replace(/^https?:/, '')) > -1);
    return i < 0 ? 0 : i;
  }

  function setShot(src, index, total) {
    const main = $('[data-main-image]');
    if (main) {
      main.src = src;
      if (index >= 0) main.dataset.at = index; else delete main.dataset.at;
    }
    all('[data-thumb]').forEach(b => b.setAttribute('aria-current', b.dataset.thumb === src ? 'true' : 'false'));
    const count = $('[data-gal-count]');
    if (count && total) count.textContent = (index + 1) + ' / ' + total;
  }

  function openDrawer() { const s = $('[data-cart-scrim]'); if (s) { s.classList.add('open'); render(); } }
  function closeDrawer() { const s = $('[data-cart-scrim]'); if (s) s.classList.remove('open'); }

  async function getCart() { const r = await fetch('/cart.js'); return r.json(); }

  async function render() {
    const cart = await getCart();
    all('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
    all('[data-cart-dot]').forEach(el => el.hidden = cart.item_count === 0);
    const total = $('[data-cart-total]'); if (total) total.textContent = money(cart.total_price);
    const lines = $('[data-cart-lines]');
    if (!lines) return;
    lines.innerHTML = cart.items.length ? cart.items.map(i => `
      <div class="cartline" data-line data-key="${i.key}">
        <a class="ph" href="${i.url}">${i.image ? '<img src="' + i.image + '" alt="">' : ''}</a>
        <div>
          <a class="disp" style="font-size:16px" href="${i.url}">${i.product_title}${i.variant_title ? ' — ' + i.variant_title : ''}</a>
          <div class="lab mut" style="margin-top:6px">${money(i.final_line_price)}</div>
          <div class="dqty">
            <div class="qty" data-qty data-line-qty>
              <button type="button" data-line-step="-1" aria-label="Decrease">&minus;</button>
              <input type="number" value="${i.quantity}" min="0" aria-label="Quantity">
              <button type="button" data-line-step="1" aria-label="Increase">+</button>
            </div>
            <button type="button" class="cta" style="font-size:10px" data-remove="${i.key}">Remove</button>
          </div>
          <p class="qcap lab" data-line-note hidden></p>
        </div>
      </div>`).join('') : '<p class="mut" style="padding:26px 0">Nothing in the bag yet.</p>';
  }

  document.addEventListener('click', async e => {
    const open = e.target.closest('[data-cart-open]');
    if (open) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }
    if (e.target.matches('[data-cart-scrim]')) { closeDrawer(); return; }
    const rm = e.target.closest('[data-remove]');
    if (rm) {
      await fetch('/cart/change.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({id: rm.dataset.remove, quantity: 0})});
      render(); return;
    }
    const menu = e.target.closest('[data-menu-open]');
    if (menu) {
      const panel = $('[data-menu]');
      if (panel) { panel.hidden = !panel.hidden; menu.setAttribute('aria-expanded', String(!panel.hidden)); }
      return;
    }
    const step = e.target.closest('[data-gal-step]');
    if (step) {
      const shots = all('[data-thumb]').map(b => b.dataset.thumb);
      const main = $('[data-main-image]');
      if (shots.length && main) {
        const at = shotAt(main, shots);
        const next = (at + Number(step.dataset.galStep) + shots.length) % shots.length;
        setShot(shots[next], next, shots.length);
      }
      return;
    }
    const thumb = e.target.closest('[data-thumb]');
    if (thumb) {
      const shots = all('[data-thumb]').map(b => b.dataset.thumb);
      setShot(thumb.dataset.thumb, shots.indexOf(thumb.dataset.thumb), shots.length);
    }
    const up = e.target.closest('[data-qty-up]'), down = e.target.closest('[data-qty-down]');
    if (up || down) {
      const input = (up || down).parentElement.querySelector('input');
      const cap = parseInt(input.getAttribute('max') || '0', 10);
      let next = Math.max(1, parseInt(input.value || '1', 10) + (up ? 1 : -1));
      if (cap > 0) next = Math.min(next, cap);
      input.value = next;
      if (up) up.disabled = cap > 0 && next >= cap;
      const other = (up || down).parentElement.querySelector('[data-qty-up]');
      if (other) other.disabled = cap > 0 && next >= cap;
    }
  });

  // Quick shop adds without leaving the page
  document.addEventListener('submit', async e => {
    const form = e.target.closest('[data-quick-form]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type=submit]');
    if (btn) btn.disabled = true;
    await fetch('/cart/add.js', {method:'POST', body: new FormData(form)});
    if (btn) btn.disabled = false;
    closeQuickShop();
    openDrawer();
  });

  // Quick shop peek — fetches the product's quick-shop template into a modal
  function qsHost() {
    let host = $('[data-qs-host]');
    if (!host) {
      host = document.createElement('div');
      host.className = 'qsscrim';
      host.setAttribute('data-qs-host', '');
      host.hidden = true;
      document.body.appendChild(host);
    }
    return host;
  }
  function closeQuickShop() {
    const host = $('[data-qs-host]');
    if (!host || host.hidden) return;
    host.hidden = true; host.innerHTML = '';
    document.documentElement.style.overflow = '';
  }
  async function openQuickShop(url) {
    const host = qsHost();
    host.hidden = false;
    host.innerHTML = '<div class="qsload lab">Loading</div>';
    document.documentElement.style.overflow = 'hidden';
    const sep = url.indexOf('?') > -1 ? '&' : '?';
    const res = await fetch(url + sep + 'view=quick-shop');
    host.innerHTML = await res.text();
    paintQuickShop();
  }
  function qsVariants(panel) {
    const tag = panel.querySelector('[data-qs-variants]');
    try { return JSON.parse(tag.textContent); } catch (err) { return []; }
  }
  function paintQuickShop() {
    const panel = $('[data-qs-panel]');
    if (!panel) return;
    const chosen = Array.from(panel.querySelectorAll('[data-qs-option]:checked')).map(i => i.value);
    panel.querySelectorAll('[data-qs-option]').forEach(i => i.closest('.qsvar').classList.toggle('on', i.checked));
    panel.querySelectorAll('[data-qs-optval]').forEach(el => {
      const v = chosen[Number(el.dataset.qsOptval) - 1];
      if (v) el.textContent = v;
    });
    const variants = qsVariants(panel);
    const variant = chosen.length
      ? variants.find(v => v.options.every((o, n) => o === chosen[n]))
      : variants.find(v => v.available) || variants[0];
    if (!variant) return;
    const id = panel.querySelector('[data-qs-id]'); if (id) id.value = variant.id;
    const price = panel.querySelector('[data-qs-price]'); if (price) price.textContent = variant.price;
    if (variant.image) qsShow(variant.image);
    const avail = panel.querySelector('[data-qs-avail]');
    if (avail) {
      const lowAt = Number(avail.dataset.lowAt || 0);
      const low = variant.available && variant.tracked && variant.qty > 0 && variant.qty <= lowAt;
      const dot = panel.querySelector('[data-qs-dotstate]');
      if (dot) dot.className = 'dot' + (variant.available ? (low ? ' low' : '') : ' out');
      const text = panel.querySelector('[data-qs-availt]');
      if (text) text.textContent = variant.available ? (low ? avail.dataset.low : avail.dataset.in) : avail.dataset.out;
    }
    const submit = panel.querySelector('[data-qs-submit]');
    if (submit) submit.disabled = !variant.available;
    const qty = panel.querySelector('[data-qty] input');
    if (qty) {
      if (variant.tracked && variant.qty > 0) { qty.max = variant.qty; qty.value = Math.min(Number(qty.value || 1), variant.qty); }
      else qty.removeAttribute('max');
    }
  }
  function qsShots() {
    const tag = $('[data-qs-shots]');
    try { return JSON.parse(tag.textContent); } catch (err) { return []; }
  }
  function qsShow(src) {
    const shots = qsShots(), index = shots.indexOf(src);
    const img = $('[data-qs-image]');
    if (img && src) {
      img.src = src;
      if (index >= 0) img.dataset.at = index; else delete img.dataset.at;
    }
    all('[data-qs-dot]').forEach(d => d.classList.toggle('on', d.dataset.qsDot === src));
    const at = $('[data-qs-at]');
    if (at) at.textContent = Math.max(0, index) + 1;
  }
  document.addEventListener('click', e => {
    const open = e.target.closest('[data-quick-shop]');
    if (open) { e.preventDefault(); openQuickShop(open.dataset.quickShop); return; }
    if (e.target.closest('[data-qs-close]') || e.target.matches('[data-qs-host]')) { closeQuickShop(); return; }
    const step = e.target.closest('[data-qs-step]');
    if (step) {
      const shots = qsShots(), img = $('[data-qs-image]');
      if (!shots.length || !img) return;
      const now = shotAt(img, shots);
      const next = (now + Number(step.dataset.qsStep) + shots.length) % shots.length;
      qsShow(shots[next]);
      return;
    }
    const dot = e.target.closest('[data-qs-dot]');
    if (dot) qsShow(dot.dataset.qsDot);
  });
  document.addEventListener('change', e => { if (e.target.matches('[data-qs-option]')) paintQuickShop(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeQuickShop(); });

  // Compose your table
  function composePaint(root) {
    const steps = Array.from(root.querySelectorAll('[data-step]'));
    const total = steps.length;
    let chosen = 0, sum = 0;
    const chosenLabel = root.dataset.chosenLabel || 'Chosen';
    steps.forEach(step => {
      const n = step.dataset.step;
      const on = step.querySelector('[data-opt].on');
      const state = step.querySelector('[data-step-state]');
      step.classList.toggle('done', !!on);
      if (state && on) state.textContent = chosenLabel;
      const row = root.querySelector('[data-sum-row="' + n + '"]');
      const slot = root.querySelector('[data-stack-slot="' + n + '"]');
      if (on) {
        chosen++;
        if (on.dataset.available !== 'false') sum += Number(on.dataset.price || 0);
        if (row) {
          row.classList.add('on');
          row.classList.toggle('gone', on.dataset.available === 'false');
          row.querySelector('[data-sum-name]').textContent = on.dataset.name;
          row.querySelector('[data-sum-price]').textContent = money(Number(on.dataset.price || 0));
        }
        if (slot) { slot.hidden = false; slot.querySelector('img').src = on.dataset.image; }
      } else if (slot) { slot.hidden = true; }
    });
    const count = root.querySelector('[data-chosen]'); if (count) count.textContent = chosen;
    const bar = root.querySelector('[data-bar]'); if (bar) bar.style.width = Math.round((chosen / total) * 100) + '%';
    const price = root.querySelector('[data-total-price]'); if (price) price.textContent = money(sum);
    const add = root.querySelector('[data-compose-add]'); if (add) add.disabled = chosen === 0;
    const empty = root.querySelector('[data-stack-empty]'); if (empty) empty.hidden = chosen > 0;
  }
  document.addEventListener('click', async e => {
    const root = e.target.closest('[data-compose]');
    if (!root) return;
    const opt = e.target.closest('[data-opt]');
    if (opt) {
      const step = opt.closest('[data-step]');
      const was = opt.classList.contains('on');
      step.querySelectorAll('[data-opt]').forEach(b => { b.classList.remove('on'); b.setAttribute('aria-pressed', 'false'); });
      if (!was) { opt.classList.add('on'); opt.setAttribute('aria-pressed', 'true'); }
      const state = step.querySelector('[data-step-state]');
      if (state && was) state.textContent = root.dataset.unchosenLabel || 'Choose one';
      composePaint(root);
      return;
    }
    if (e.target.closest('[data-compose-clear]')) {
      root.querySelectorAll('[data-opt]').forEach(b => { b.classList.remove('on'); b.setAttribute('aria-pressed', 'false'); });
      root.querySelectorAll('[data-step-state]').forEach(s => s.textContent = root.dataset.unchosenLabel || 'Choose one');
      composePaint(root);
      return;
    }
    const addBtn = e.target.closest('[data-compose-add]');
    if (addBtn) {
      // Sold-out choices are set aside and named; the rest go into the bag.
      const seen = {}, items = [], missing = [], titles = {};
      root.querySelectorAll('[data-opt].on').forEach(b => {
        const id = Number(b.dataset.variant);
        if (!id) return;
        if (b.dataset.available === 'false') { missing.push(b.dataset.name || ''); return; }
        titles[id] = b.dataset.name || '';
        if (seen[id]) { items[seen[id] - 1].quantity += 1; return; }
        items.push({id: id, quantity: 1});
        seen[id] = items.length;
      });
      const note = root.querySelector('[data-compose-error]');
      const say = t => { if (note) { note.hidden = !t; note.textContent = t || ''; } };
      say('');
      if (!items.length) {
        say(addBtn.dataset.allGone || 'Everything you chose is sold out just now.');
        return;
      }
      addBtn.disabled = true;
      const post = payload => fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify(payload)
      });
      try {
        // The cart add is all-or-nothing, so a refused batch is retried one line
        // at a time and the pieces that can be bought still land in the bag.
        let added = items.length, reason = '';
        const res = await post({items});
        if (!res.ok) {
          added = 0;
          for (const item of items) {
            const one = await post({items: [item]});
            if (one.ok) { added++; continue; }
            const why = await one.json().catch(() => null);
            if (why && (why.description || why.message) && !reason) reason = why.description || why.message;
            missing.push(titles[item.id] || '');
          }
        }
        addBtn.disabled = false;
        const names = missing.filter(Boolean);
        if (!added) { say(reason || addBtn.dataset.allGone || 'Nothing could be added just now.'); return; }
        let line = addBtn.dataset.addedText || 'Available items added to your bag.';
        if (names.length) {
          const list = names.length === 1 ? names[0]
            : names.slice(0, -1).join(', ') + ' and ' + names[names.length - 1];
          const tpl = addBtn.dataset.someGone || 'Sold out: [pieces].';
          line += ' ' + (tpl.indexOf('[pieces]') > -1 ? tpl.replace('[pieces]', list) : tpl + ' ' + list);
        }
        say(line);
        if ($('[data-cart-scrim]')) openDrawer(); else window.location.href = '/cart';
      } catch (err) {
        addBtn.disabled = false;
        say('The bag did not respond. Try again.');
      }
    }
  });
  all('[data-compose]').forEach(composePaint);

  // Variant picker keeps the hidden select in step with the swatches
  document.addEventListener('change', e => {
    if (!e.target.matches('[data-option]')) return;
    const form = e.target.closest('form');
    const chosen = Array.from(form.querySelectorAll('[data-option]:checked')).map(i => i.value).join(' / ');
    const select = form.querySelector('[data-variant-select]');
    if (!select) return;
    Array.from(select.options).forEach(o => { if (o.textContent.trim() === chosen) select.value = o.value; });
    // Lead the gallery with the chosen variant's own photograph
    const opt = select.options[select.selectedIndex];
    // Quantity ceiling follows the chosen variant's inventory
    const cap = opt && opt.dataset.variantMax ? parseInt(opt.dataset.variantMax, 10) : 0;
    const qtyInput = form.querySelector('[data-qty] input');
    if (qtyInput) {
      const qtyBox = qtyInput.closest('[data-qty]');
      if (cap > 0) {
        qtyInput.max = cap;
        qtyInput.value = Math.min(parseInt(qtyInput.value || '1', 10), cap);
        if (qtyBox) qtyBox.dataset.qtyMax = cap;
      } else {
        qtyInput.removeAttribute('max');
        if (qtyBox) delete qtyBox.dataset.qtyMax;
      }
      const upBtn = form.querySelector('[data-qty-up]');
      if (upBtn) upBtn.disabled = cap > 0 && Number(qtyInput.value) >= cap;
    }
    const img = opt && opt.dataset.variantImage;
    if (img) {
      const shots = all('[data-thumb]').map(b => b.dataset.thumb);
      setShot(img, shots.indexOf(img), shots.length);
    }
  });

  // One path for the drawer and the cart page alike. Shopify caps a line at what
  // is in stock and returns the quantity it settled on, so the ceiling is read
  // from its answer rather than guessed at.
  async function commitLine(line, box, asked) {
    const input = box.querySelector('input');
    const cap = Number(box.dataset.cap || 0);
    const note = line.querySelector('[data-line-note]');
    const say = t => { if (note) { note.hidden = !t; note.textContent = t || ''; } };
    if (cap > 0 && asked > cap) { asked = cap; input.value = cap; say('Only ' + cap + ' available'); }
    box.querySelectorAll('button').forEach(b => b.disabled = true);
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({id: line.dataset.key, quantity: asked})
      });
      const cart = await res.json().catch(() => null);
      const found = cart && cart.items ? cart.items.filter(i => i.key === line.dataset.key)[0] : null;
      const got = found ? found.quantity : (res.ok ? asked : Number(input.value || 1));
      input.value = got;
      say(got < asked ? 'Only ' + got + ' available' : '');
      if (line.closest('[data-cart-lines]')) { render(); return; }
      window.location.reload();
    } catch (err) {
      box.querySelectorAll('button').forEach(b => b.disabled = false);
      say('That did not go through. Try again.');
    }
  }

  document.addEventListener('click', e => {
    const step = e.target.closest('[data-line-step]');
    if (!step) return;
    const line = step.closest('[data-line]');
    const box = step.closest('[data-line-qty]');
    if (!line || !box) return;
    const input = box.querySelector('input');
    const cap = Number(box.dataset.cap || 0);
    const asked = Math.max(0, Number(input.value || 1) + Number(step.dataset.lineStep));
    if (cap > 0 && asked > cap) {
      const note = line.querySelector('[data-line-note]');
      if (note) { note.hidden = false; note.textContent = 'Only ' + cap + ' available'; }
      return;
    }
    commitLine(line, box, asked);
  });

  // A typed quantity is held to the same ceiling as the steppers, then committed
  // rather than left sitting in the field failing browser validation.
  document.addEventListener('change', e => {
    const input = e.target;
    if (!input.matches('[data-qty] input')) return;
    const box = input.closest('[data-qty]');
    const floor = Number(input.getAttribute('min') || 1);
    const cap = Number(box.dataset.cap || box.dataset.qtyMax || input.getAttribute('max') || 0);
    let want = parseInt(input.value, 10);
    if (isNaN(want)) want = floor;
    want = Math.max(floor, want);
    if (cap > 0 && want > cap) want = cap;
    input.value = want;
    const up = box.querySelector('[data-qty-up]');
    if (up) up.disabled = cap > 0 && want >= cap;
    const line = input.closest('[data-line]');
    if (line && box.hasAttribute('data-line-qty')) commitLine(line, box, want);
  });

  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });

  const FAV_KEY = 'bh-saved';
  const readFavs = () => { try { return JSON.parse(localStorage.getItem(FAV_KEY)) || []; } catch (e) { return []; } };
  const paintFavs = () => {
    const list = readFavs();
    document.querySelectorAll('[data-fav-card]').forEach(b => {
      const on = list.indexOf(b.dataset.favCard) > -1;
      b.classList.toggle('on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  };
  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-fav-card]');
    if (!btn) return;
    e.preventDefault();
    const list = readFavs(), at = list.indexOf(btn.dataset.favCard);
    if (at > -1) { list.splice(at, 1); } else { list.push(btn.dataset.favCard); }
    try { localStorage.setItem(FAV_KEY, JSON.stringify(list)); } catch (err) {}
    paintFavs();
  });
  paintFavs();
})();
